import { GrowthBook } from "@growthbook/growthbook";
import { autoAttributesPlugin } from "@growthbook/growthbook/plugins";
import * as Sentry from "@sentry/react";

import { defaultValues } from "@/app/featureFlags/defaultValues";
import type { AppFeatures } from "@/app/featureFlags/types";
import { mapToDefinitions } from "@/app/featureFlags/utils";
import { CommonTrackingEvents, rudderAnalytics } from "@/lib/rudderstack";

const clientKey = import.meta.env.VITE_PUBLIC_GROWTHBOOK_CLIENT_KEY;

export const growthbook = new GrowthBook<AppFeatures>({
  apiHost: "https://cdn.growthbook.io",
  clientKey,
  enableDevMode: import.meta.env.VITE_PUBLIC_ENVIRONMENT === "development",
  trackingCallback: (experiment, result) => {
    rudderAnalytics.track(CommonTrackingEvents.EXPERIMENT_VIEWED, {
      experimentId: experiment.key,
      variationId: result.key,
    });
  },
  plugins: [autoAttributesPlugin()],
  features: mapToDefinitions(defaultValues),
});

export async function initializeGrowthBook() {
  if (!clientKey) {
    return;
  }

  const initResult = await growthbook.init({ streaming: true });

  if (initResult.error) {
    Sentry.captureException(initResult.error);
  }
}
